import React from 'react';

import { NavLink } from 'react-router-dom';

export default function TetriaryNav({ navLinks }) {
  return (
    <nav>
      <div>
        <div className="flex items-center">
          <ul className="flex mt-0 w-full text-sm font-medium">
            {navLinks.map((link) => {
              return (
                <li key={link.url}>
                  <NavLink
                    end
                    to={link.url}
                    className={({ isActive }) => {
                      return isActive
                        ? 'block py-3 pt-0 px-4 border-b-2 text-primary-600 hover:text-primary-600 dark:text-primary-500 dark:border-primary-500 border-primary-600'
                        : 'block py-3 pt-0 px-4 text-gray-500 dark:text-gray-400 hover:text-primary-600 hover:border-b-2 dark:hover:text-primary-500 dark:hover:border-primary-500 hover:border-primary-600';
                    }}
                    aria-current="page"
                  >
                    {link.title}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </nav>
  );
}
